// "Playful Frost" glass surface for BaseCard (the fixed-size hero card used by
// login / profile selection). Prefix: qag-. Frosted warm-white fill over the
// page pattern, a pronounced top sheen, and a soft teal float shadow.
export const baseCardStyles = `
  .qag-root {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .qag-card {
    position: relative;
    overflow: hidden;
    background-color: var(--glass-flat-bg);
    -webkit-backdrop-filter: var(--glass-flat-filter);
    backdrop-filter: var(--glass-flat-filter);
    border: 1px solid var(--glass-flat-border);
    border-radius: var(--rad-catchup-xlarge);
    height: var(--h-catchup-card);
    width: var(--w-catchup-card);
    box-shadow: var(--glass-flat-edge), var(--glass-float);
  }
  .qag-card::before {
    content: "";
    position: absolute;
    inset: 0 0 auto 0;
    height: 180px;
    background: var(--sheen-medium);
    pointer-events: none;
    z-index: 0;
  }
  .qag-inner {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    padding: 2rem;
    height: 100%;
  }
`;
